// extracted by css-extract-rspack-plugin
export default {"dot":"amPVYNU5L2cQhjCB"};